export const buildChildrenMap = (nodes) => {
  const map = new Map();
  nodes.forEach((node) => {
    if (node.parentId == null) return;
    const siblings = map.get(node.parentId);
    if (siblings) siblings.push(node);
    else map.set(node.parentId, [node]);
  });
  return map;
};

export const getDescendantIds = (nodes, id, childrenMap = buildChildrenMap(nodes)) => {
  const ids = new Set();
  const stack = [id];
  while (stack.length) {
    (childrenMap.get(stack.pop()) ?? []).forEach((child) => {
      ids.add(child.id);
      stack.push(child.id);
    });
  }
  return ids;
};

export const getVisibleNodes = (nodes, childrenMap = buildChildrenMap(nodes)) => {
  const root = nodes.find((node) => node.parentId == null);
  if (!root) return [];

  const visible = new Set();
  const stack = [root];
  while (stack.length) {
    const node = stack.pop();
    visible.add(node.id);
    if (!node.collapsed) stack.push(...(childrenMap.get(node.id) ?? []));
  }
  return nodes.filter((node) => visible.has(node.id));
};

export const deriveTitle = (nodes) => {
  const root = nodes.find((node) => node.parentId == null);
  const firstLine = (root?.text ?? '').trim().split('\n')[0];
  return (firstLine || 'Untitled mind map').slice(0, 100);
};
